import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Events } from 'ionic-angular';

@Component({
  selector: 'page-newShelf',
  templateUrl: 'newShelf.html'
})

export class NewShelfPage {

  newName: string = "";

  constructor(public navCtrl: NavController, public events: Events) {
  }

  saveShelf(event) {
    console.log("Save Shelf: " + this.newName);

    if (this.newName.length > 0) {
      console.log("Sending shelf:add event");
      this.events.publish("shelf:add", this.newName);
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/newShelf/newShelf.ts